import React from 'react';
import {
  isGoogleLoggedIn,
  setGoogleAccessToken,
  setGoogleRefreshToken,
  getCodeFromSearchParam,
  getFreeeAccessToken,
} from '../utils/AuthService'
import { Redirect } from 'react-router-dom'
import axios from 'axios';
import qs from 'qs';
import { updateGsuiteRefreshToken} from "../utils/ApiClient";
import { consoleLog} from "../utils/log";

const GOOGLE_TOKEN_URL = process.env.REACT_APP_GOOGLE_TOKEN_URL
const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID
const CLIENT_SECRET = process.env.REACT_APP_GOOGLE_CLIENT_SECRET
const REDIRECT_URI = process.env.REACT_APP_GOOGLE_REDIRECT_URI

class AuthGoogle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // ログインチェック結果.
      location: props.location,
      isGoogleLoggedIn: false,
      isLoading: true
    }
  }

  componentDidMount() {
    const code = getCodeFromSearchParam(this.state.location.search)
    const data = {
      grant_type: 'authorization_code',
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      redirect_uri: REDIRECT_URI,
      code: `${code}`
    };
    const url = GOOGLE_TOKEN_URL
    const option = {
      method: 'POST',
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      data: qs.stringify(data),
      url,
    };
    axios(option)
      .then((response) => {
        const freeeAccessToken = getFreeeAccessToken();
        const gsuiteRefreshToken = response.data.refresh_token;
        setGoogleAccessToken(response.data.access_token);
        setGoogleRefreshToken(gsuiteRefreshToken);
        this.setState({
          isGoogleLoggedIn: true,
          isLoading: false
        });
        updateGsuiteRefreshToken(freeeAccessToken, gsuiteRefreshToken);

      }).catch((e) => console.log(e))
  }

  render() {
    const { isLoading, isGoogleLoggedIn } = this.state

    if (isLoading) {
      return (
        <div>
          now loading
        </div>
      )
    }

    if (isGoogleLoggedIn) {
      return (
        <div>
          <Redirect to="/register" />
        </div>
      )
    } else {
      return (
        <div>
          <Redirect to="/GoogleLogin" />
        </div>
      )
    }
  }
}
export default AuthGoogle;